import openMeniu from './open-menu.action';

export default openMeniu;
